import script from "./StickyBar.vue?vue&type=script&lang=ts&setup=true"
export * from "./StickyBar.vue?vue&type=script&lang=ts&setup=true"

import "./StickyBar.vue?vue&type=style&index=0&id=2f2df4d9&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src1008117636/src/bitbucket.org/labtravelfactory/booking-funnel-xftless/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2f2df4d9"]])

export default __exports__